import Box from '@mui/material/Box'

const BouncingDots = () => (
  <Box 
    sx={{
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'flex-end',
      height: 25,
      width: 25,
      '& div': {
        bgcolor: 'background.secondary.main',
        borderRadius: '50%',
        width: 5,
        height: 5,
        animation: 'bouncing 0.6s infinite alternate',
        '&:nth-of-type(2)': {
          animationDelay: '0.2s',
        },
        '&:nth-of-type(3)': {
          animationDelay: '0.4s',
        },
      },
    }}
  >
    <div></div>
    <div></div>
    <div></div>
  </Box>
)

export default BouncingDots
